import { takeLatest, SagaGenerator } from 'typed-redux-saga'

import { getContratosSaga, postRefinancingBeginSaga } from '@store/refinanciamento/contratos/sagas'
import { postContratacaoSaga } from '@store/refinanciamento/contratacao/sagas'
import { ContratacaoTypes } from '@store/refinanciamento/contratacao/types'

import { ContrachequeDocumentosTypes } from './contrachequeDocumentos/types'
import { ContratosTypes } from './contratos/types'
import { DadosBancariosTypes } from './dadosBancarios/types'
import { DadosPessoaisTypes } from './dadosPessoais/types'
import { DocumentosTypes } from './documentos/types'
import { DocumentosAssinaturaTypes } from './documentosAssinatura/types'
import { EnderecoTypes } from './endereco/types'
import { FotoDocumentosTypes } from './fotoDocumentos/types'
import { ConsultaMargemTypes } from './marginAcceptResult/types'
import { SimulacaoTypes } from './simulacao/types'
import { PropostaTypes } from './proposta/types'
import { ValidaTypes } from './validateISafe/types'
import { AuthenticationTypes } from './authentication/types'
import { getBancosSaga } from './dadosBancarios/sagas'
import { getDadosPessoaisSaga, postDadosPessoaisSaga } from './dadosPessoais/sagas'
import { getEnderecoSaga } from './endereco/sagas'
import {
  buscarDocumentosSaga,
  captureDocumentsSaga,
  signatureDocumentsSaga,
} from './documentos/sagas'
import { finalizarPropostaSaga } from './documentosAssinatura/sagas'
import { sendToS3PDFSaga } from './fotoDocumentos/sagas'
import { postMarginAcceptSaga, postMarginResultSaga } from './marginAcceptResult/sagas'
import { dadosPropostaSaga, getPropostasSaga, postDadosAntigaPropostaSaga } from './proposta/sagas'
import { getSimulacaoSaga, getRecalculoSimulacaoSaga } from './simulacao/sagas'
import { postTrackingRefinSaga } from './trackingRefin/sagas'
import { postAutorizacaoISafeSaga } from './validateISafe/sagas'
import { getAuthenticationSaga } from './authentication/sagas'

export default function* watch(): SagaGenerator<void> {
  yield* takeLatest(ContratosTypes.CONTRATOS_REQUEST, getContratosSaga)
  yield* takeLatest(ContratosTypes.REFINANCING_BEGIN_REQUEST, postRefinancingBeginSaga)
  yield* takeLatest(SimulacaoTypes.SIMULACAO_REQUEST, getSimulacaoSaga)
  yield* takeLatest(SimulacaoTypes.TRACKING_REFIN, postTrackingRefinSaga)
  yield* takeLatest(ConsultaMargemTypes.CONSULTA_MARGEM_ACCEPT_REQUEST, postMarginAcceptSaga)
  yield* takeLatest(ConsultaMargemTypes.CONSULTA_MARGEM_RESULT_REQUEST, postMarginResultSaga)
  yield* takeLatest(PropostaTypes.DADOS_PROPOSTA_REQUEST, dadosPropostaSaga)
  yield* takeLatest(PropostaTypes.GET_PROPOSTAS_REQUEST, getPropostasSaga)
  yield* takeLatest(SimulacaoTypes.GET_SIMULACAO_RECALCULO, getRecalculoSimulacaoSaga)
  yield* takeLatest(ValidaTypes.POST_ISAFE_AUTORIZACAO, postAutorizacaoISafeSaga)
  yield* takeLatest(DocumentosTypes.CAPTURA_DOCUMENTOS_REQUEST, captureDocumentsSaga)
  yield* takeLatest(DocumentosTypes.DOCUMENTOS_ASSINATURA_REQUEST, signatureDocumentsSaga)
  yield* takeLatest(DocumentosTypes.BUSCAR_DOCUMENTOS_SAGA, buscarDocumentosSaga)
  yield* takeLatest(DocumentosAssinaturaTypes.FINALIZAR_PROPOSTA, finalizarPropostaSaga)
  yield* takeLatest(PropostaTypes.DADOS_PROPOSTA_ANTIGA_REQUEST, postDadosAntigaPropostaSaga)
  yield* takeLatest(FotoDocumentosTypes.SEND_TO_S3_SAGA, sendToS3PDFSaga)
  yield* takeLatest(ContrachequeDocumentosTypes.SEND_TO_S3_SAGA_CONTRACHEQUE, sendToS3PDFSaga)
  yield* takeLatest(DadosBancariosTypes.BANCOS_REQUEST, getBancosSaga)
  yield* takeLatest(EnderecoTypes.ENDERECO_REQUEST, getEnderecoSaga)
  yield* takeLatest(ContratacaoTypes.CONTRATACAO_REQUEST, postContratacaoSaga)
  yield* takeLatest(DadosPessoaisTypes.GET_DADOS_PESSOAIS_REQUEST, getDadosPessoaisSaga)
  yield* takeLatest(DadosPessoaisTypes.POST_DADOS_PESSOAIS_REQUEST, postDadosPessoaisSaga)
  yield* takeLatest(AuthenticationTypes.AUTHENTICATION_REQUEST, getAuthenticationSaga)
}
